<template>
    <div>
        <el-form :inline="true" :model="searchForm"  class="forTbFilter">
                <el-form-item label="流量池名称：">
                <el-input v-model.trim="searchForm.poolName" clearable></el-input>
            </el-form-item>
            <el-form-item class="btnArea">
                 <el-button type="primary"  @click="getFluxPoolMgtListHandler">搜索查询</el-button>
                <el-button type="primary"  @click="showAddFluxPool">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border>
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column prop="poolName" label="流量池名称"></el-table-column>
            <el-table-column prop="poolId" label="流量池ID"></el-table-column>
            <el-table-column prop="supplierName" label="运营商"></el-table-column>
            <el-table-column prop="totalFlow" label="流量池总流量(G)" width="120"></el-table-column>
            <el-table-column prop="useFlow" label="流量池使用流量(G)" width="130"></el-table-column>
            <el-table-column prop="remainsFlow" label="流量池剩余流量(G)" width="130"></el-table-column>
            <el-table-column prop="usePp" label="使用率（百分比）" ></el-table-column>
            <el-table-column prop="warnPp" label="告警率（百分比）"></el-table-column>
            <el-table-column prop="warnPhone" label="告警手机号"></el-table-column>
            <el-table-column prop="updateTime" label="流量更新时间"></el-table-column>
            <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                    <el-button type="text" @click="showEditFluxPool(scope.row)">编 辑</el-button>
                </template>
            </el-table-column>
        </el-table>  
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>
        <el-dialog :title="title" :visible.sync="poolVisibale" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="poolForm" :model="poolForm" :rules="poolRules" label-width="120px">
                <el-form-item label="流量池名称：" prop="poolName">
                    <el-input v-model="poolForm.poolName"></el-input>
                </el-form-item>
                <el-form-item label="流量池ID：" prop="poolId">
                    <el-input v-model="poolForm.poolId"></el-input>
                </el-form-item>
                <el-form-item label="供应商：" prop="supplierId">
                    <el-select v-model="poolForm.supplierId" clearable>
                        <el-option v-for="item in supplierOption" :value="item.id" :key="item.id" :label="item.supplierName"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="告警阈值：" prop="warnPp">
                    <el-input v-model="poolForm.warnPp" placeholder="请输入已流量使用的百分比（选填）"></el-input>
                </el-form-item>
                 <el-form-item label="告警手机号：" prop="warnPhone">
                    <el-input v-model="poolForm.warnPhone" placeholder="告警手机号（选填）"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureAddOrEditFluxPool">确 定</el-button>
            </div>
        </el-dialog>     
    </div>
</template>

<script>
import {getFluxPoolMgtList, addFluxPool, editFluxPool} from '@/api/fluxPools.js'
import common from '@/utils/common.js'
export default {
    data(){         
        return {
            searchForm: {
                agentId:'',
                poolName:''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },  
            poolVisibale: false,
            title: '新增流量池',
            optFlag: '',
            poolForm: {
                currentId: null,
                poolName: '',
                agentId: '',
                poolId:'',
                supplierId: '',
                groupId:'',
                simData:'',
                usePp:'',
                warnPp:'',
                warnPhone:'',
                type:''
            },
            typesOption:[

                {
                    id:'0',
                    name:'运营商流量池'
                },
                {
                    id:'1',
                    name:'自运营流量池'
                }
            ],
            supplierOption: [],
            agentsOption: [],
            poolRules: {
                poolName: [{required: true, message: '请输入流量池名称', trigger: 'blur'}],
                supplierId: [{required: true, message: '请选择供应商', trigger: 'blur change'}],
                groupId: [{required: false, message: 'CT卡必填', trigger: 'blur'}],
            }
        }
    },
    methods: {
        cancel(){
            this.poolVisibale = false;
            this.$refs.poolForm.resetFields();
        },
        getFluxPoolMgtListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);            
            getFluxPoolMgtList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        showAddFluxPool(){
            this.poolVisibale = true;
            this.title = '新增流量池';
            this.optFlag = 'add';
            common.getSupplierOptsCom(this, 'supplierOption')
            common.getNextAgentOptsCom(this, 'agentsOption');  
        },
        showEditFluxPool(row){
            this.poolVisibale = true;
            this.title = '编辑增流量池';
            this.optFlag = 'edit';
            common.getSupplierOptsCom(this, 'supplierOption')
            common.getNextAgentOptsCom(this, 'agentsOption');
            this.poolForm = JSON.parse(JSON.stringify(row));
        },
        sureAddOrEditFluxPool(){
            this.$refs.poolForm.validate(valid => {
                if(valid){
                    var data = this.poolForm
                    if(this.optFlag == 'add'){
                        addFluxPool(data).then(res => callback(res))
                    }else{
                        editFluxPool(data).then(res => callback(res))
                    }
                }
                var _this = this;
                function callback(res){
                    if(res.data.code == 200){
                        _this.getFluxPoolMgtListHandler();
                        _this.poolVisibale = false;
                        
                    }else{
                        _this.$message.error(res.data.message)
                    }                     
                }
            })
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getFluxPoolMgtListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getFluxPoolMgtListHandler();
        }       
    },
    created () {
        common.getNextAgentOptsCom(this, 'agentsOption');
        this.getFluxPoolMgtListHandler();
    }
}
</script>

<style lang="scss" scoped>

</style>

